const topics = [
  { label: '热血战斗', count: '2.3万讨论', hot: true },
  { label: '恋爱甜宠', count: '1.8万讨论', hot: true },
  { label: '异世界转生', count: '2.1万讨论', hot: true },
  { label: '修仙玄幻', count: '1.9万讨论', hot: false },
  { label: '搞笑日常', count: '2.5万讨论', hot: true },
  { label: '悬疑推理', count: '1.5万讨论', hot: false },
  { label: '都市职场', count: '1.2万讨论', hot: false },
  { label: '恐怖惊悚', count: '1.6万讨论', hot: false },
  { label: '科幻未来', count: '1.4万讨论', hot: false },
  { label: '治愈温馨', count: '1.7万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
           大家都在讨论的漫画话题，找到你喜欢的圈子
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <a
                key={topic.label}
                href="#topics"
                onClick={(e) => e.preventDefault()}
                className="group relative inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 bg-background-50 hover:bg-primary-50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                {topic.hot && (
                  <span className="absolute -top-1.5 -right-1.5 w-3 h-3 bg-primary-500 rounded-full border-2 border-background-50"></span>
                )}
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                  {topic.label}
                </span>
                <span className="text-xs text-foreground-400">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}